import { Box, IBoxProps } from 'native-base';
import React from 'react';
import { useSafeAreaInsets } from 'react-native-safe-area-context';

export type StatusBarHeaderProps = {
  bg?: IBoxProps['bg'];
};

/**
 * Safe-area spacer for light screens. Do not mount a RN <StatusBar> here — when Destinations
 * stays under Tabs on real devices (e.g. BrowserStack), it would paint a white bar / dark icons
 * over Product's hero.
 *
 * Icon style for light screens (Purchases, Auth, etc.) must be set by those screens/stacks
 * via StatusBar.setBarStyle('dark-content') on focus.
 */
export default function HeaderStatusBar({ bg = 'white' }: StatusBarHeaderProps) {
  const { top } = useSafeAreaInsets();

  return <Box bg={bg} h={`${top}px`} />;
}
